<template>
	<div style="height: 100%; display: flex; flex-direction: column; padding: 0;">
		<div style="flex: 1; min-height: 0; overflow: auto; padding: 1px 0;">
			<div v-for="item in list" class="section-block">
				<div class="section-head">{{item.createTime}}</div>
				<div class="section-cont">{{item.remark}}</div>
			</div>
		</div>
		<div class="add-btn-box">
			<el-button type="primary" size="mini" style="width: 100%" @click="dialogShow = true">添加备注</el-button>
		</div>
		<el-dialog title="添加备注" :visible.sync="dialogShow" width="450px" :close-on-click-modal="false">
			<el-form style="margin: -10px 0;">
				<el-form-item style="margin: 0">
					<el-input v-model="remark" type="textarea" placeholder="请输入备注信息" maxlength="200"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogShow = false">取 消</el-button>
				<el-button type="primary" @click="submitRemark()">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data () {
		return {
			list: [],
			remark: '',
			dialogShow: false
		}
	},
	computed: {
		currentShop () {
			return this.$store.state.currentShop;
		},
		currentConversation () {
			return this.$store.state.currentConversation;
		}
	},
	mounted () {
		this.getDataList()
	},
	methods: {
		// 获取数据列表
		getDataList () {
			let data = {
				sessionId: this.currentConversation.id
			}

			this.$axios.post(API_ROOT.url + '/SessionApi.getClientRemark', data).then(result => {
				if (result.status) {
					this.list = result.data
				} else {
					this.$message.error('获取备注信息失败：' + result.msg);
				}
			}, response => {
				this.$message.error('网络繁忙，获取备注信息失败！');
			})
		},

		// 提交备注信息
		submitRemark () {
			if (!this.remark) {
				this.$message.error('请输入备注信息')
				return
			}
			let data = {
				sessionId: this.currentConversation.id,
				remark: this.remark
			}
			this.$axios.post(API_ROOT.url + '/SessionApi.addClientRemark', data).then(result => {
				if (result.status) {
					this.remark = ''
					this.$message.success('提交成功')
					this.dialogShow = false
					this.getDataList()
				} else {
					this.$message.error('提交备注信息失败：' + result.msg);
				}
			}, response => {
				this.$message.error('网络繁忙，提交备注信息失败！');
			})
		}
	}
}
</script>

<style scoped lang="less">
.section-block {
	margin: 15px 10px;
	font-size: 12px;
	line-height: 16px;
	.section-head {
		padding: 0 6px 5px;
	}
	.section-cont {
		padding: 6px 10px;
		background: #f5f6f7;
		border-radius: 10px;
		color: rgb(102, 102, 102);
	}
}
.add-btn-box {
	padding: 10px;
	box-shadow: 0px 2px 4px #000;
}
</style>


// WEBPACK FOOTER //
// src/pages/aside/userRemark.vue